import baseService from '@/utils/http/axios'
const indexPop = {
    state: {
        // 弹窗是否可见
        visible: false,
        // 弹窗数据
        popupData: null,
        // 加载状态
        loading: false,
    },

    mutations: {
        SET_VISIBLE: (state, visible) => {
            state.visible = visible
        },
        SET_POPUP_DATA: (state, data) => {
            state.popupData = data
        },
        SET_LOADING: (state, loading) => {
            state.loading = loading
        }
    },

    actions: {
        // 检查弹窗是否可见
        checkIndexPop({ commit, state }) {
            commit('SET_LOADING', true)
            let requeryParam = {
                url: '/admin/v1/checkOpenPop',
                method: 'post',
                data: {}
            }
            baseService(requeryParam).then((res: any) => {
                if (res.data.show == 1) {
                    commit('SET_VISIBLE', true)
                    commit('SET_POPUP_DATA', res.data)
                }
            }).catch(error => {
                console.log(error)
            }).finally(() => {
                commit('SET_LOADING', false)
            })
        },
        // 关闭弹窗（组件中调用这个）
        closePopup({ commit }) {
            commit('SET_VISIBLE', false)
        }
    },
    namespaced: true
}

export default indexPop
